import React, { Suspense } from "react";
import './App.css';
import { ElfsightWidget } from 'react-elfsight-widget';
import i18n from 'i18next';
import {initReactI18next, useTranslation} from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Header from './components/Header/Header.jsx';
import Main from './components/main/main.jsx';
import Numbers from './components/Numbers/Numbers.jsx';
import Agenda from './components/Agenda/Agenda.jsx';
import SpeakersFrom from './components/Speakers from/Speakers from.jsx';
// import WhatIWillLearn from './components/WhatIWillLearn/WhatIWillLearn.jsx';
import FourKeys from './components/FourKeys/FourKeys.jsx';
// import FAQ from './components/FAQ/FAQ.jsx';
// import Audience from './components/Audience/Audience.jsx';
import Photos from './components/Photos/Photos.jsx';
// import TagCloud from './components/TagCloud/TagCloud.jsx';
import Speakers from './components/Speakers/Speakers.jsx';
// import Packages from './components/Packages/Packages.jsx';
// import AskCompany from "./components/AskCompany/AskCompany";
// import Enterprise from "./components/Enterprise/Enterprise";
// import Workshops from "./components/Workshops/Workshops";
import Become from "./components/Become/Become";
// import Sponsors from "./components/Sponsors/Sponsors";
// import Partners from "./components/Partners/Partners";
// import PC from "./components/PC/PC";
import Mission from "./components/Mission/Mission";
// import Reviews from './components/Reviews/Reviews.jsx';
// import JoinCommunity from './components/JoinCommunity/JoinCommunity';
import Team from './components/Team/Team.jsx';
import Footer from './components/footer/Footer.jsx';
import Countdown from './components/CountDown/CountDown';
import Broadcast_main from './components/Broadcast_main/Broadcast_main';
// import Event_about from './components/Event_about/Event_about'
import tg from './img/tg.svg';
import yb_icon from './img/yb_icon.svg';
import HeadPartner from './components/HeadPartner/HeadPartner';


i18n
.use(initReactI18next)
.use(HttpApi)
.init({
  lng: 'ua',
  fallbackLng: "ua",
  supportedLngs: ['ua', 'ru'],
  debug: false,
  backend: {
    loadPath: `assets/locales/{{lng}}/translation.json`, 
  },
  detection: {
    order: ["localStorage", "cookie"],
    caches: ["localStorage", "cookie"],
  },
  interpolation: {
    escapeValue: false,
  },
  debug: true,
  react: {
    wait: true,
    useSuspense: false
  }
})

const App = (props) => {
  const [scroll, setScroll] = React.useState(0);
  const pageLink = window.location.href.toString();
  const indexUtm = pageLink.indexOf('?');
  const utm = pageLink.slice(indexUtm+1);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const { t } = useTranslation();

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <main>
      <a 
      href='https://t.me/+aMS2A9h8JAExYjM6'
      target='_blank'
      rel="noreferrer"
      className={scroll < 300 ? "fixed_button main_btn main_btn--first main_btn_tg" : "fixed_button main_btn main_btn--first main_btn_tg show"}
      >
        {t("app.event_group")}<img className='tg_icon' src={tg}></img>
      </a>
      <a 
      href={`https://www.youtube.com/watch?v=XuxfA5fL4aw`}
      target='_blank'
      rel="noreferrer"
      className={scroll < 300 ? "fixed_button main_btn main_btn--first" : "fixed_button main_btn main_btn--first show"}
      >
        {t("app.join_live")}<img className='yb_icon' src={yb_icon}></img>
      </a>
      {/* <a 
      href={`https://geekle.us/ticketfree/1646932857434x557347668339458050?lang=ua${indexUtm !== -1 ? `&${utm}` : ''}`}
      target='_blank'
      rel="noreferrer"
      className={scroll < 300 ? "fixed_button main_btn main_btn--first" : "fixed_button main_btn main_btn--first show"}
      >
        Реєстрація
      </a> */}
      <Header /> 
      <Main />
      <Numbers />
      <HeadPartner />
      <FourKeys />
      <Mission />
      <Photos />
      <SpeakersFrom />
      <Broadcast_main />
      {/* <Agenda /> */}
      {/* <Speakers /> */}
      {/* <WhatIWillLearn /> */}
      {/* <FAQ /> */}
      {/* <Audience /> */}
      {/* <TagCloud /> */}
      {/* <Event_about /> */}
      {/* <Packages /> */}
      {/* <AskCompany /> */}
      {/* <Enterprise /> */}
      {/* <Become /> */}
      {/* <Workshops /> */}
      {/* <Sponsors /> */}
      {/* <Partners /> */}
      {/* <PC /> */}
      {/* <Reviews /> */}
      {/* <JoinCommunity /> */}
      <Team />
      {/* <ElfsightWidget widgetID="b38daf23-87d0-4e91-87f3-9adc750a7cae" /> */}
      <Footer />
      <Countdown />
    </main> 
  );
}

export default App;